document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('[data-disable-on-click]');
  buttons.forEach(button => {
    button.addEventListener('click', event => {
      event.target.classList.add('disabled');
    });
  });
});

document.querySelectorAll('#logout').forEach(function (element) {
  element.addEventListener('click', function (e) {
    e.preventDefault();
    document.getElementById('logout-form').submit();
  });
});
